module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-7-4ee620d02f2459f4a49f582d4bc38923.jpg";